module.exports = __webpack_public_path__ + "img/9a43c02f8cbafe5c0ab25f8b6ccaac69.png";